import calc from 'calculatorjs'

export const getters = {
  tpItems (state, getters, rootState) {
    if (!state.createPrepare) return []
    const list = []
    state.createPrepare.parcels.forEach(parcel => {
      parcel.extraInfo.tpTaobaoTradeItems.forEach(tpItem => {
        list.push(tpItem)
      })
    })
    return list
  },

  tpItemsCcMethodBy91 (state, getters, rootState) {
    const list = []
    getters.tpItems.forEach(tpItem => {
      if (tpItem.itemCcMethod === '91') {
        if (!list.find(item => item.itemCcName === tpItem.itemCcName)) {
          list.push(tpItem)
        }
      } else if (tpItem.itemStdRules && tpItem.itemStdRules.declTypeG1MaxQty && tpItem.itemStdRules.declTypeG1MaxQty !== 999999) {
        const itemQty = getters.tpItems
          .filter(item => item.itemCcName === tpItem.itemCcName)
          .reduce((prev, curr) => calc.add(prev, curr.itemQtyAvg || curr.itemQty), 0)
        if (itemQty >= tpItem.itemStdRules.declTypeG1MaxQty && !list.find(item => item.itemCcName === tpItem.itemCcName)) {
          list.push(tpItem)
        }
      }
    })
    return list
  },

  tpItemsCcMethod70 (state, getters, rootState) {
    return getters.tpItems.filter(tpItem => tpItem.itemCcMethod === '70')
  },

  trfTpItems (state, getters, rootState) {
    if (!state.createPrepare) return []
    if (getters.shippingRatesInfo.transport !== 'se') return []
    const tpItems = []
    state.createPrepare.parcels.forEach(parcel => {
      // 针对公司申报或子母单
      if (parcel.tnoPriCount < 5 && rootState.edition !== 's') return
      parcel.extraInfo.tpTaobaoTradeItems.forEach(tpItem => {
        // 家具不计算
        const cccCode = tpItem.itemCccCode || tpItem.catCccCode || ''
        const cctags = tpItem.itemCctags || tpItem.catCctags
        if (tpItem.itemMold && tpItem.itemMold.indexOf('4') > -1 && cccCode.indexOf('94') === 0 && !cctags) return

        if (tpItem.isADTAX || tpItem.isLRTT || tpItem.isIRC02) {
          const findTpItem = tpItems.find(item => item.catCccCode === tpItem.catCccCode)
          if (findTpItem && findTpItem.itemTrackingNoList.includes(tpItem.itemTrackingNo)) return
          if (findTpItem) {
            findTpItem.count += 1
            findTpItem.itemTrackingNoList.push(tpItem.itemTrackingNo)
            return
          }

          let tipsTextCompany = ''
          let tipsTextPerson = ''
          let tipsText2 = ''
          let sort = 0
          if (tpItem.isLRTT) {
            tipsTextCompany = `由於${tpItem.itemTwName}涉及貨物稅，海關要求必須G1正式報關。`
            tipsTextPerson = `由於${tpItem.itemTwName}涉及貨物稅，海關要求必須G1正式報關。`
            sort = 1
          } else if (tpItem.isADTAX) {
            tipsTextCompany = `由於${tpItem.itemTwName}涉及反傾銷稅，海關要求必須G1正式報關。`
            tipsTextPerson = `由於${tpItem.itemTwName}涉及反傾銷稅，海關要求必須G1正式報關。`
            if (parcel.tnoPriCount < 5) {
              tipsTextPerson += '您可以選擇一次只寄回2件與其他商品集運，或用G1正式報關一次寄回。'
            }
            sort = 2
          } else if (tpItem.isIRC02) {
            tipsTextCompany = `由於${tpItem.itemTwName}海關要求商檢，因此必須G1正式報關。`
            tipsTextPerson = `由於${tpItem.itemTwName}海關要求商檢，因此必須G1正式報關。`
            if (tpItem.catTrfExemptAmt > 0 && tpItem.catTrfExemptQty > 0) {
              tipsTextPerson += `（個人申報G1貨值低於${tpItem.catTrfExemptAmt}元並且數量低於${tpItem.catTrfExemptQty}個可免商檢）`
            } else if (tpItem.catTrfExemptAmt > 0) {
              tipsTextPerson += `（個人申報G1貨值低於${tpItem.catTrfExemptAmt}元可免商檢）`
            }
            tipsText2 = '因應本週海關嚴打，巧巧郎暫時使用最謹慎的通關策略保護您的貨物通關安全，之後每天巧巧郎會密切關注海關尺度並及時調整。'
            sort = 3
          }

          tpItems.push({
            ...tpItem,
            count: 1,
            itemTrackingNoList: [tpItem.itemTrackingNo],
            tipsTextCompany,
            tipsTextPerson,
            tipsText2,
            tnoPriCount: parcel.tnoPriCount,
            sort,
          })
        }
      })
    })
    tpItems.sort((a, b) => a.sort - b.sort)
    return tpItems
  },

  tpItemsInclTaxMaxWt (state, getters, rootState) {
    if (!state.createPrepare) return []
    const list = []
    state.createPrepare.parcels.forEach(parcel => {
      parcel.extraInfo.tpTaobaoTradeItems.forEach(tpItem => {
        if (tpItem.itemMold === '0') return
        let parcelWeight = 0
        state.createPrepare.parcels.forEach(parcel2 => {
          if (parcel2.extraInfo.tpTaobaoTradeItems.find(tpItem2 => {
            return tpItem2.itemCcName === tpItem.itemCcName && tpItem2.itemInclTaxMaxWt === tpItem.itemInclTaxMaxWt
          })) {
            parcelWeight = calc.add(parcelWeight, parcel2.weight)
          }
        })
        if (tpItem.itemCcName && Number(tpItem.itemInclTaxMaxWt) < parcelWeight) {
          list.push(tpItem)
        }
      })
    })
    return list
  },

  tpItemsDeclRealValue (state, getters, rootState) {
    return getters.tpItems.filter(item => item.itemStdRules && String(item.itemStdRules.declRealValue) === '1')
  },

  onlyNotIncTax (state, getters, rootState) {
    if (getters.shippingRatesInfo.transport === 'se' && state.createPrepare && state.createPrepare.hasBizParcel) return true
    if (getters.shippingRatesInfo.transport === 'se' && getters.hasMutilTwParcel) return true
    if (getters.tpItemsInclTaxMaxWt.length > 0) return true
    if (state.createPrepare.parcels.length > 50) return true
    return false
  },

  onlyBusi (state, getters, rootState) {
    if (getters.tpItemsCcMethod70.length) return true
    if (getters.traRealAmtsTWDTotal > 0 && getters.traRealAmtsTWDTotal < 2000) return false
    return false
  },
}
